import React, {useState, useContext} from 'react'
import PropTypes from 'prop-types'
import Overlay from './components/Overlay'

const HighlightOverlayContext = React.createContext()


function HighlightOverlay({className, children}) {
	const [overlayState, setOverlayState] = useState({
		collection: [],
		visibleIndex: null,
		visible: false,
	})

	const showOverlay = ({collection, visibleIndex}) => setOverlayState({collection, visibleIndex, visible: true})
	const hideOverlay = () => setOverlayState(({collection, visibleIndex}) => ({
		collection,
		visibleIndex,
		visible: false,
	}))
	const showNext = () => setOverlayState(({collection, visibleIndex, visible}) => {
		if (visibleIndex + 1 >= collection.length) return {visibleIndex: 0, collection, visible}
		return {visibleIndex: visibleIndex + 1, collection, visible}
	})
	const showPrevious = () => setOverlayState(({collection, visibleIndex, visible}) => {
		if (visibleIndex - 1 < 0) return {visibleIndex: collection.length - 1, collection, visible}
		return {visibleIndex: visibleIndex - 1, collection, visible}
	})

	const {collection, visibleIndex, visible} = overlayState

	return <>
		<HighlightOverlayContext.Provider
			value={{showOverlay, hideOverlay, showNext, showPrevious}}>
			<Overlay
				showArrows={collection.length > 1}
				toShow={collection[visibleIndex]}
				visible={visible}
				onHide={hideOverlay}
				onPrevious={showPrevious}
				onNext={showNext}/>
			{children}
		</HighlightOverlayContext.Provider>
	</>
}

HighlightOverlay.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
}

HighlightOverlay.defaultProps = {
	className: '',
}

export const HighlightOverlayProvider = HighlightOverlay

export function useHighlightOverlay() {
	return useContext(HighlightOverlayContext)
}
